export type ListPriceFiltersMessages = {
  filterByLabel: string;
  valueLabel: string;
  search: string;

  //Filter Options messages
  allOption: string;
  codeOption: string;
  brandOption: string;
  statusOption: string;
  titleOption: string;
  eanOption: string;

  statusTrueOption: string;
  statusFalseOption: string;
};

export const LIST_PRICE_FILTERS_MESSAGES: ListPriceFiltersMessages = {
  filterByLabel: "Filtrar por",
  valueLabel: "Valor",
  search: "Buscar",

  //Filter Options messages
  allOption: "Todos",
  codeOption: "Código",
  brandOption: "Marca",
  statusOption: "Status",
  titleOption: "Título",
  eanOption: "EAN",

  statusTrueOption: "Ativo",
  statusFalseOption: "Desativado",
};
